import React from 'react'
import PropTypes from 'prop-types';

export const ResumenTransaccionRow = ({ destination, carrier, amount, isSuccess }: any) => {
    let classIcon = "fas fa-check-circle";
    if (!isSuccess) {
        classIcon = "fas fa-times-circle"
    }
    return (
        <tr key="">
            <td><i className={classIcon}></i></td>
            <td>{destination}</td>
            <td>{carrier}</td>
            <td>{amount}</td>
        </tr>
    )
}
ResumenTransaccionRow.propTypes = {
    destination: PropTypes.string.isRequired,
    carrier: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    isSuccess: PropTypes.bool.isRequired
}

